import { DominoMaskIcon } from './DominoMaskIcon';

/**
 * author: Andrew Nenakhov
 * id 4621ACB1-6F3D-414D-8724-B276982DB087
 * name domino-mask
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/domino-mask.svg
 * tags
 */
export const ZorroMaskIcon = DominoMaskIcon;
export default ZorroMaskIcon